import { BarrelTypeMap } from "../Components/Map"
import { roundTo, concatClipId } from "./DataProcess"


export const extractDataByBatter = (record, stat) => {
  let pData = {
    batterList: [], dataByBatter: {}
  }
  let rawBatterData = {}

  const isEmpty = (val) => (val === undefined || val[0] === undefined)
  const parseNum = (num) => {
    if (num !== undefined && num[0] !== undefined) {
      if (num.includes('.')) return parseFloat(num)
      return parseInt(num)
    }
    return num
  }
  const onBase = ['1B', '2B', '3B', 'HR', 'E']
  const notAB = ['SF', 'SH']
  const swingCall = ['S', 'F', 'I']
  const strike = ['S', 'F', 'I', 'C']
  let evIdResult = {}
  let CIDBatterMap = {}
  let CIDCallMap = {}

  const PR_NEEDED = ['Angle', 'ExitSpeed']

  for (const p of record) {
    let cid = concatClipId(p.Date, p.Clip_Id)
    CIDBatterMap[cid] = p.Batter
    if (rawBatterData[p.Batter] === undefined) {
      let initBatterData = {
        result: { PA: 0, AB: 0, '1B': 0, '2B': 0, '3B': 0, HR: 0, SO: 0, BB: 0, E: 0, HBP: 0 },
        stat: { pitches: 0, swing: 0, miss: 0, zswing: 0, oswing: 0, zcontact: 0, zone: 0, ozone: 0 },
        barrel: { weak: 0, top: 0, under: 0, solid: 0, barrel: 0, flareburner: 0 },
        cumulated: { ev_sum: 0, ev_count: 0, la_sum: 0, la_count: 0, ev_max: 0 },
        inplay_clip_ids: [],
        pitchtypes: {},
        pr: {
          count: 0, swing: 0,
          l_angle: 0, l_angle_count: 0,
          ev_max: -1000, ev_sum: 0, ev_count: 0,
          ev_fl_sum: 0, ev_fl_count: 0, ev_gd_sum: 0, ev_gd_count: 0,
          hard_count: 0, swsp_count: 0, miss: 0,
        },
        exit: [],
        xyexit: [],
        hit: { 'Barrel': [], 'Flare-or-Burner': [], 'Poorly-Topped': [], 'Poorly-Under': [], 'Solid-Contact': [], 'Weak-Contact': [] },
        angle: {
          oz: [0, 0, 0, 0],
          z: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        vole: {
          oz: [0, 0, 0, 0],
          z: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        }
      }

      rawBatterData[p.Batter] = initBatterData
      pData.batterList.push(p.Batter)
    }
    let player = p.Batter, type = p.TaggedPitchType
    if (p['Balls'] === '1' && p['Strikes'] === '1') {
      rawBatterData[player].result.PA++
    }
    if (rawBatterData[player].pitchtypes[type] === undefined) {
      let initPitchTypeData = {
        v_count: 0, v_sum: 0, v_max: 0, s_count: 0, s_sum: 0, seff_sum: 0, s_max: 0,
        b_count: 0, v_break: 0, h_break: 0, count: 0, strike: 0, sdir_count: 0, sdir_sum: 0,
        gyro_sum: 0, gyro_count: 0
      }
      rawBatterData[player].pitchtypes[type] = initPitchTypeData
    }
    //update result
    if (p.PitchCall === 'I') {
      if (onBase.includes(p.PlayResult)) {
        rawBatterData[player].result[p.PlayResult]++
        rawBatterData[player].result.AB++
      } else if (!notAB.includes(p.PlayResult)) {
        rawBatterData[player].result.AB++
      }
      rawBatterData[player].inplay_clip_ids.push(cid)
    } else if (!isEmpty(p.KorBB)) {
      if (p.KorBB === 'K') {
        rawBatterData[player].result.SO++
        rawBatterData[player].result.AB++
      } else {
        if (p.KorBB === 'HBP') rawBatterData[player].result.HBP++
        else rawBatterData[player].result.BB++
      }
    }
    //update stat
    rawBatterData[player].stat.pitches++
    if (p.PitchCall !== 'C' && p.PitchCall !== 'B') rawBatterData[player].stat.swing++
    if (p.PitchCall === 'S') rawBatterData[player].stat.miss++
    CIDCallMap[cid] = p.PitchCall

    //update pr

    rawBatterData[p.Batter].pr.count++
    if (p.PitchCall === 'S' || p.PitchCall === 'F' || p.PitchCall === 'I') rawBatterData[p.Batter].pr.swing++
    if (p.PitchCall === 'I') evIdResult[cid] = p.HitType
    if (p.PitchCall === 'S') rawBatterData[p.Batter].pr.miss++

  }


  for (const e of stat) {
    let cid = concatClipId(e.Date, e.Clip_Id)
    let exitSpeed = parseFloat(e.ExitSpeed), angle = parseFloat(e.Angle)

    if (CIDBatterMap[cid] === undefined) continue

    if (e.Zone === 'IN') rawBatterData[CIDBatterMap[cid]].stat.zone++
    else rawBatterData[CIDBatterMap[cid]].stat.ozone++

    if (CIDCallMap[cid] !== undefined) {
      if (swingCall.includes(CIDCallMap[cid])) {
        if (e.Zone === 'IN') {
          rawBatterData[CIDBatterMap[cid]].stat.zswing++
          if (CIDCallMap[cid] !== 'S') rawBatterData[CIDBatterMap[cid]].stat.zcontact++
        } else {
          rawBatterData[CIDBatterMap[cid]].stat.oswing++
        }
      }
    }
    if (evIdResult[cid] === undefined) continue
    else {
      if (evIdResult[cid] === 'G') {
        rawBatterData[CIDBatterMap[cid]].pr.ev_gd_sum += exitSpeed
        rawBatterData[CIDBatterMap[cid]].pr.ev_gd_count++
      } else {
        rawBatterData[CIDBatterMap[cid]].pr.ev_fl_sum += exitSpeed
        rawBatterData[CIDBatterMap[cid]].pr.ev_fl_count++
      }
      rawBatterData[CIDBatterMap[cid]].pr.ev_sum += exitSpeed
      rawBatterData[CIDBatterMap[cid]].pr.ev_count++
      if (exitSpeed >= 95 * 1.61) rawBatterData[CIDBatterMap[cid]].pr.hard_count++
      if (e.ExitSpeed >= rawBatterData[CIDBatterMap[cid]].pr.ev_max) rawBatterData[CIDBatterMap[cid]].pr.ev_max = exitSpeed
      rawBatterData[CIDBatterMap[cid]].pr.l_angle += angle
      rawBatterData[CIDBatterMap[cid]].pr.l_angle_count++
      if (angle >= 8 && angle <= 32) rawBatterData[CIDBatterMap[cid]].pr.swsp_count++
    }
  }

  // console.log(stat)
  for (const p of stat) {
    let cid = concatClipId(p.Date, p.Clip_Id), player
    if (CIDBatterMap[cid] !== undefined) player = CIDBatterMap[cid]
    else continue
    //update cumulated
    if (rawBatterData[player].inplay_clip_ids.includes(cid)) {
      let ev = parseNum(p.ExitSpeed), la = parseNum(p.Angle)
      rawBatterData[player].cumulated.ev_sum += ev
      rawBatterData[player].cumulated.ev_count++
      if (ev > rawBatterData[player].cumulated.ev_max) {
        rawBatterData[player].cumulated.ev_max = ev
      }
      rawBatterData[player].cumulated.la_sum += la
      rawBatterData[player].cumulated.la_count++

      //設定逐球擊球初速/擊球仰角
      if (p.ExitSpeed > 0) {
        // console.log(record)
        var rc = record.filter(r => (concatClipId(r.Date, r.Clip_Id) === concatClipId(p.Date, p.Clip_Id)) && r.PitchCall === "I")
        if (rc.length > 0)
          rawBatterData[player].exit.push({ "Clip_Id": p.Clip_Id, "ExitSpeed": p.ExitSpeed, "Angle": p.Angle })
      }
      rawBatterData[player].xyexit.push({ "X_ExitSpeed": p.X_ExitSpeed, "Y_Angle": p.Y_Angle })

      // console.log(p)
      if (p.X_ExitSpeed > 0 || p.Y_Angle > 0) {
        rc = record.filter(r => (concatClipId(r.Date, r.Clip_Id) === concatClipId(p.Date, p.Clip_Id)) && r.PitchCall === "I")
        // console.log(rc)
        if (rc.length > 0) {
          // if (rawBatterData[player].hit[p.Barrel] === undefined) {
          //   rawBatterData[player].hit[p.Barrel] = []
          // }
          rawBatterData[player].hit[p.Barrel].push({ "x": p.X_ExitSpeed, "y": p.Y_Angle, "r": 2 })
        }
      }
    }

    var Ozone = ['Ozone1', 'Ozone2', 'Ozone3', 'Ozone4']
    var Zone = ['Zone1', 'Zone2', 'Zone3', 'Zone4', 'Zone5', 'Zone6', 'Zone7', 'Zone8', 'Zone9']

    var oz_index = Ozone.findIndex(e => e === p.O_Zone)
    var z_index = Zone.findIndex(e => e === p.O_Zone)
    // var za_index = ZoneAll.findIndex(e => e === p.O_Zone)

    var rc = record.filter(r => (concatClipId(r.Date, r.Clip_Id) === concatClipId(p.Date, p.Clip_Id)) && r.PitchCall === "I")
    if (rc.length > 0) {
      if (oz_index > -1) {
        if (parseFloat(p.Angle) > 0) {
          rawBatterData[player].angle.oz[oz_index] += parseFloat(p.Angle)
          if (rawBatterData[player].angle.oz[oz_index] > parseFloat(p.Angle))
            rawBatterData[player].angle.oz[oz_index] = rawBatterData[player].angle.oz[oz_index] / 2
        }

        if (parseFloat(p.ExitSpeed) > 0) {
          rawBatterData[player].vole.oz[oz_index] += parseFloat(p.ExitSpeed)
          if (rawBatterData[player].vole.oz[oz_index] > parseFloat(p.Angle))
            rawBatterData[player].vole.oz[oz_index] = rawBatterData[player].vole.oz[oz_index] / 2
        }
      }

      if (z_index > -1) {
        if (parseFloat(p.Angle) > 0) {
          rawBatterData[player].angle.z[z_index] += parseFloat(p.Angle)
          if (rawBatterData[player].angle.z[z_index] > parseFloat(p.Angle))
            rawBatterData[player].angle.z[z_index] = rawBatterData[player].angle.z[z_index] / 2
        }

        if (parseFloat(p.ExitSpeed) > 0) {
          // if(player === '方田會'){
          //   console.log(p)
          //   console.log(rawBatterData[player].vole.z[z_index])
          // }
          rawBatterData[player].vole.z[z_index] += parseFloat(p.ExitSpeed)
          // if(player === '梅準璋'){
          //   console.log('ExitSpeed : ' + p.ExitSpeed)
          //   console.log(rawBatterData[player].vole.z[z_index])
          // }
          if (rawBatterData[player].vole.z[z_index] > parseFloat(p.ExitSpeed))
            rawBatterData[player].vole.z[z_index] = rawBatterData[player].vole.z[z_index] / 2

        }
      }
    }


    // if (oz_index > -1) {
    //   if (parseFloat(p.Angle) > 0) {
    //     rawBatterData[player].angle.oz[oz_index] += parseFloat(p.Angle)
    //     rawBatterData[player].angle.oz_count[oz_index]++
    //     angle.oz_count[oz_index]++
    //   }

    //   if (parseFloat(p.ExitSpeed) > 0) {
    //     rawBatterData[player].vole.oz[oz_index] += parseFloat(p.ExitSpeed)
    //     rawBatterData[player].vole.oz_count[oz_index]++
    //     vole.oz_count[oz_index]++
    //   }
    // }
    // if (z_index > -1) {
    //   if (parseFloat(p.Angle) > 0) {
    //     rawBatterData[player].angle.z[z_index] += parseFloat(p.Angle)
    //     rawBatterData[player].angle.z_count[z_index]++
    //     angle.z_count[z_index]++
    //   }
    //   if (parseFloat(p.ExitSpeed) > 0) {
    //     rawBatterData[player].vole.z[z_index] += parseFloat(p.ExitSpeed)
    //     rawBatterData[player].vole.z_count[z_index]++
    //     vole.z_count[z_index]++
    //   }
    // }
  }
  // console.log(anglePR)
  // console.log(volePR)

  //console.log(rawBatterData)
  // console.log(vole)

  // console.log(rawBatterData)
  //Pack up & calaulated data
  for (const p in rawBatterData) {
    let init = {
      overall: [], pitchTypes: [], pr: {}, exit: [], xyexit: [], hit: [],
      angleZone: { ozone: [0, 0, 0, 0], ozonePR: [0, 0, 0, 0], zone: [0, 0, 0, 0, 0, 0, 0, 0, 0], zonePR: [0, 0, 0, 0, 0, 0, 0, 0, 0] },
      veloZone: { ozone: [0, 0, 0, 0], ozonePR: [0, 0, 0, 0], zone: [0, 0, 0, 0, 0, 0, 0, 0, 0], zonePR: [0, 0, 0, 0, 0, 0, 0, 0, 0] }
    }
    //data for pitchtypes
    for (const pt in rawBatterData[p].pitchtypes) {
      let ptd = [], rptd = rawBatterData[p].pitchtypes[pt]
      ptd.push(pt) //pitchtype
      let va, sa, vb, hb, se, gd, sd, sp
      va = rptd.v_count === 0 ? '-' : Math.round(rptd.v_sum * 10 / rptd.v_count) / 10
      sa = rptd.s_count === 0 ? '-' : Math.round(rptd.s_sum * 10 / rptd.s_count) / 10
      vb = rptd.b_count === 0 ? '-' : Math.round(rptd.v_break * 10 / rptd.b_count) / 10
      hb = rptd.b_count === 0 ? '-' : Math.round(rptd.h_break * 10 / rptd.b_count) / 10
      se = rptd.s_count === 0 ? '-' : Math.round(rptd.seff_sum * 10 / rptd.s_count) / 10
      gd = rptd.gyro_count === 0 ? '-' : Math.round(rptd.gyro_sum * 10 / rptd.gyro_count) / 10
      sd = rptd.sdir_count === 0 ? '-' : Math.round(rptd.sdir_sum * 10 / rptd.sdir_count) / 10
      sp = rptd.count === 0 ? '-' : Math.round(rptd.strike * 10 * 100 / rptd.count) / 10
      ptd.push(va); ptd.push(rptd.v_max); ptd.push(sa); ptd.push(rptd.s_max)
      ptd.push(vb); ptd.push(hb); ptd.push(se); ptd.push(gd); ptd.push(sd); ptd.push(sp)
      init.pitchTypes.push(ptd)
    }
    //overall performance
    let tb1 = [], tb2 = []
    let res = rawBatterData[p].result, st = rawBatterData[p].stat, cum = rawBatterData[p].cumulated
    let H = res['1B'] + res['2B'] + res['3B'] + res['HR']
    tb1.push(res.PA); tb1.push(res.AB); tb1.push(H); tb1.push(res['1B']);
    tb1.push(res['2B']); tb1.push(res['3B']); tb1.push(res['HR']); tb1.push(res['SO']); tb1.push(res['BB']);
    let avg = res.AB > 0? Math.round(H * 1000 / res.AB) / 1000 : '-'
    let wOBA = Math.round(((0.72 * res.BB) + (0.75 * res.HBP) + (0.9 * res['1B']) + (0.92 * res.E) + (1.24 * res['2B']) + (1.56 * res['3B']) + (1.95 * res.HR)) * 1000 / (res.PA)) / 1000
    let ev = cum.ev_count === 0 ? '-' : roundTo(cum.ev_sum / cum.ev_count, 1)
    let maxev = cum.ev_count === 0 ? '-' : cum.ev_max
    let la = cum.la_count === 0 ? '-' : roundTo(cum.la_sum / cum.la_count, 1)
    let whiff = st.swing === 0 ? '-' : roundTo(st.miss / st.swing, 3) * 100
    tb1.push(avg); tb1.push(wOBA); tb1.push(ev); tb1.push(maxev);
    tb1.push(la); tb1.push(isNaN(whiff) ? whiff : roundTo(whiff, 1))
    init.overall.push(tb1)
    //TODO: tb2 -> The second table (swing%, zswing%, ...)
    //console.log('st', p, st)
    let swingavg = st.pitches === 0 ? '-' : Math.round(st.swing * 1000 / st.pitches) / 10
    let zswing = st.zone === 0 ? '-' : Math.round(st.zswing * 1000 / st.zone) / 10, oswing = st.ozone === 0 ? '-' : Math.round(st.oswing * 1000 / st.ozone) / 10
    let zcontact = st.zone === 0 ? '-' : Math.round(st.zcontact * 1000 / st.zone) / 10
    let br = {}
    for (const k in rawBatterData[p].hit) {
      br[BarrelTypeMap[k]] = rawBatterData[p].hit[k].length
    }
    tb2.push(swingavg); tb2.push(zswing); tb2.push(oswing); tb2.push(zcontact)
    tb2.push(br.weak); tb2.push(br.top); tb2.push(br.under); tb2.push(br.flareburner); tb2.push(br.solid); tb2.push(br.barrel);
    init.overall.push(tb2)


    init.pr = setPR(rawBatterData[p].pr)

    //設定逐球擊球初速/擊球仰角
    let exit = { velo: [], angle: [] }
    for (const x in rawBatterData[p].exit) {
      // console.log( rawBatterData[p].exit[x])
      exit.velo.push({ x: parseInt(x) + 0.1, y: parseFloat(rawBatterData[p].exit[x].ExitSpeed) })
      exit.angle.push({ x: parseInt(x) + 0.1, y: parseFloat(rawBatterData[p].exit[x].Angle) })
    }
    init.exit = exit
    init.xyexit = rawBatterData[p].xyexit
    init.hit = rawBatterData[p].hit

    init.angleZone.ozone = rawBatterData[p].angle.oz
    init.angleZone.zone = rawBatterData[p].angle.z
    init.veloZone.ozone = rawBatterData[p].vole.oz
    init.veloZone.zone = rawBatterData[p].vole.z
    // for (const z in rawBatterData[p].angle.oz) {
    //   var oz1 = rawBatterData[p].angle.oz[z] / rawBatterData[p].angle.oz_count[z]
    //   init.angleZone.ozone[z] = isNaN(oz1) ? 0 : oz1
    //   var zo1 = rawBatterData[p].vole.oz[z] / rawBatterData[p].vole.oz_count[z]
    //   init.veloZone.ozone[z] = isNaN(zo1) ? 0 : zo1
    // }
    // for (const z in rawBatterData[p].vole.z) {
    //   var oz2 = rawBatterData[p].angle.z[z] / rawBatterData[p].angle.z_count[z]
    //   init.angleZone.zone[z] = isNaN(oz2) ? 0 : oz2
    //   var zo2 = rawBatterData[p].vole.z[z] / rawBatterData[p].vole.z_count[z]
    //   init.veloZone.zone[z] = isNaN(zo2) ? 0 : zo2
    // }


    pData.dataByBatter[p] = init
  }
  //console.log(pData.dataByBatter)
  return pData
}
function setPR(pr) {
  let pack = {
    Count: pr.count,
    'LA(°)': pr.l_angle_count === 0 ? '-' : `${Math.round(pr.l_angle * 100 / pr.l_angle_count) / 100}°`,
    'EV Max': pr.ev_max === -1000 ? '-' : pr.ev_max,
    'EV Avg': pr.ev_count === 0 ? '-' : Math.round(pr.ev_sum * 100 / pr.ev_count) / 100,
    'EV FB/LD': pr.ev_fl_count === 0 ? '-' : Math.round(pr.ev_fl_sum * 100 / pr.ev_fl_count) / 100,
    'EV GD': pr.ev_gd_count === 0 ? '-' : Math.round(pr.ev_gd_sum * 100 / pr.ev_gd_count) / 100,
    'Swing%': `${Math.round(pr.swing * 10000 / pr.count) / 100}%`,
    'SwSp%': pr.l_angle_count === 0 ? '-' : `${Math.round(pr.swsp_count * 10000 / pr.l_angle_count) / 100}%`,
    'Hard#': pr.ev_count === 0 ? '-' : pr.hard_count,
    'Hard%': pr.ev_count === 0 ? '-' : `${Math.round(pr.hard_count * 10000 / pr.ev_count) / 100}%`,
    'Whiff%': pr.swing === 0 ? '-' : `${Math.round(pr.miss * 10000 / pr.swing) / 100}%`
    //'DIST MAX': 0,
    //'DIST AVG': 0
  }
  return pack
}